module.exports = __webpack_public_path__ + "img/32.dd382506.png";